export const HdfcOptimaRestoreReqBody = (data) => {
  console.log("data from submit HdfcOptimaRestoreReqBody", data);

  let selfDetails = null; // These details will be added to the client details
  // If self is not selected in insured list then this plan is not for him/her
  let selfSelected = false;
  data?.insureds?.forEach((insured, i)=> {
   if(insured["relationShip"] === "Self") {
    selfSelected = true;
    selfDetails = insured; // getting self details to add into client details
    // data.insureds.splice(i, 1); // removing from insureds list, because we are not sending self details in insured list/dependants array
    return;
   }
  });

  if(!selfSelected){
    return null;
  }

  // TODO: Self insured will be client and removed from dependants array

  // For Individual
  if (data["insureds"].length === 1) { // length 0 means there are one insured, those details are now available in selfDetails object
    /* Creating an object for Individual. */
   let individualObject = {
      client: {
        occuptionCode: "",
        name: data["proposer_name"],
        // age: data["insureds"][0]["Age"], // TODO: discuss
        age: selfDetails["Age"],
        smokerFlag: 0,
        genderCode: data.gender.charAt(0),
        annualIncome: 500000,
        dependants: [],
        address: {
            pincode: data["pincode"]
        },
        product: {
          productCode: data["period"]==="2" ? 11120 : 11119,
          sumAssured: data["sumInsuredValue"],
          SACCode: 1
        },
        hdcCheck: false,
        ipaRiderCheck: false,
        pCheck: false,
        ipaSa: "",
        hdcSa: "",
        ALCOHOL: "No",
        PAN_MASALA: "No"
      }
    };

    let individual = { individual: individualObject };
    return individual;
  }

  let countAdult = 0, countChild = 0;

  let familyObject = null; // for Family

  /* Counting the number of adults, children */
  for (const item of data["insureds"]) {
    if (item.relationShip === "Dependent Child") {
      countChild++;
    } 
    else {
      countAdult++;
    }
  }

  /* Creating an object for Family */
  familyObject = {
    client: {
      occuptionCode: "",
      name: data["proposer_name"],
      age: selfDetails["Age"], // TODO: discuss
      smokerFlag: 0,
      genderCode: data.gender.charAt(0),
      annualIncome: 500000,
      familyPlan: `${countAdult}+${countChild}`,
      dependants: [],
      address: {
          pincode: data["pincode"]
      },
      product: {
        productCode: data["period"] === "2" ? 11122 : 11121,
        sumAssured: data["sumInsuredValue"],
        SACCode: 1
      },
      hdcCheck: false,
      ipaRiderCheck: false,
      pCheck: false,
      ipaSa: "",
      hdcSa: "",
      ALCOHOL: "No",
      PAN_MASALA: "No"
    }
  };
  
  for (let i = 0; i < data["insureds"].length; i++) {
    
    let relationship = data["insureds"][i]["relationShip"];
    if(relationship==="Self") continue;

    let gender = getGender(data, relationship);

    // for family
    familyObject["client"]["dependants"].push({
      occuptionCode: "",
      name: data["insureds"][i]["name"],
      age: data["insureds"][i]["Age"],
      smokerFlag: 0,
      genderCode: gender,
      // "relationshipCode": "14",
      annualIncome: 500000,
      professionCode: "",
      hdcCheck: false,
      ipaRiderCheck: false,
      pCheck: false,
      unlimitedRiderCheck: false,
      ipaRiderSa: null,
      ipaSa: "",
      hdcSa: "0",
      ALCOHOL: "No",
      PAN_MASALA: "No", 
      product: {
        SACCode : relationship === "Dependent Child" ? 3 : 2
      }
    });
  }

  let floater = { floater: familyObject };

  return floater;
};

function getGender(data, relationship) {
  if (relationship === "Spouse") {
    return data.gender === "Male" ? "F" : "M";
  } else if (relationship === "Self") {
    return data.gender.charAt(0);
  } else {
    return "F";
  }
}